import { render, staticRenderFns } from "./event-create-attributes.vue?vue&type=template&id=1be526ea"
import script from "./event-create-attributes.vue?vue&type=script&lang=js"
export * from "./event-create-attributes.vue?vue&type=script&lang=js"
import style0 from "./event-create-attributes.vue?vue&type=style&index=0&id=1be526ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports